import QRCode from 'qrcode';

const cache = new Map<string, Promise<string>>();

/** A data-URL QR for a ticket code, used on screen and in the ticket PDF. */
export function qrDataUrl(text: string, width = 220): Promise<string> {
  const key = `${width}:${text}`;
  let promise = cache.get(key);
  if (!promise) {
    promise = QRCode.toDataURL(text, { width, margin: 1, errorCorrectionLevel: 'M' });
    cache.set(key, promise);
  }
  return promise;
}
